import React from 'react';
import { TransfersPage } from './TransfersPage';
import { transfersV2Api } from '../services/api';

const TransfersV2Page = () => {
  return (
    <TransfersPage
      apiOverride={transfersV2Api}
      titleOverride="Virement V2"
      subtitleOverride="Virements avec notifications email avancees"
      testIdPrefix="v2-"
    />
  );
};

export default TransfersV2Page;
